import { createSelector } from '@reduxjs/toolkit'
import { z } from 'zod'

import { SuperadminProfileSchema } from '../../domain/profile.domain'
import { forSuperadminApi } from '../_base.api'
import { emptyContent, makeBuilders } from '../common'

export const superadminProfileApi = forSuperadminApi.injectEndpoints({
    endpoints: builder => {
        const { buildQuery, buildMutation } = makeBuilders(builder)
        return {
            getProfile: buildQuery({
                input: z.void(),
                output: SuperadminProfileSchema,
                query: () => ({
                    url: '/profile',
                    method: 'GET',
                }),
                providesTags: ['Profile'],
                keepUnusedDataFor: 1,
            }),
            editProfile: buildMutation({
                input: SuperadminProfileSchema.pick({ name: true, email: true }).partial(),
                output: emptyContent(),
                query: body => ({
                    url: '/profile',
                    method: 'PUT',
                    body,
                }),
                invalidatesTags: ['Profile'],
            }),
        }
    },
})

export const { useGetProfileQuery, useEditProfileMutation } = superadminProfileApi

export const selectProfile = createSelector(
    superadminProfileApi.endpoints.getProfile.select(),
    profile => profile.data,
)
